import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Delete = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 18"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#FF3B30"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M12.408 7.221c0 5.832.739 8.468-4.23 8.468s-4.215-2.636-4.215-8.468M13.354 4.985H3.018M10.378 4.985s.338-2.738-2.193-2.738c-2.53 0-2.191 2.738-2.191 2.738" />
      </g>
    </svg>
  );
};
export default Delete;
